import axios from "axios";
import moment from "moment";
import { isNavigationFailure } from "vue-router";

import CollectPayments from "../../../Payments/CollectPayments.vue";
import PaymentRequest from "../../../Payments/PaymentRequestComp.vue";
import ResourceComponent from "../../VeinsTracker/ResourceComponent/ResourceComponent.vue";
import PatientTasksTable from "../../../components/TaskTable.vue";
import AuditLogComponent from "../../../components/AuditLogComponent.vue";

export default {
  components: {
    PaymentRequest,
    ResourceComponent,
    PatientTasksTable,
    AuditLogComponent,
    CollectPayments,
  },
  props: [
    "p_visitId",
    "taskpatientId",
    "button_Name",
    "FetchTableData",
    "AppModelId",
  ],
  data() {
    return {
      //props
      patientId: this.taskpatientId,
      //show Tasks
      modelBackDrop: true,
      showTasks: false,
      showAuditLog: false,
      limitAmount: 0,
      //reminder
      btnProColl: false,
      Reminder: [],
      patResSumm: [],
      displayRem: false,
      displayReceipt: false,
      displayPayMethod: false,
      //refund Var
      displayRefundMethod: false,
      LimitRefund: null,
      refundMethodType: 0,
      refundAmountModal: false,
      refundAmount: "",
      //refund Var
      filteredPaymentRequests: "",
      patId: "",
      pageNumber: 1,
      pageSize: 50,
      orderByCol: 1,
      asc_desc: "asc",
      remeberOrder: "",
      firstTime: true,
      totalPages: 0,
      totalRows: 0,
      SendReceiptRequest: {
        PatientId: 0,
        VisitId: 0,
        LocalDateTime: new Date(),
        BillNo: 0,
        PNDX: 0,
        Email: "",
        Phone: "",
        DC: "",
      },
      //Editor
      setReadonly: false,
      // email Editor
      Eeditor: false,
      Esubj: false,
      Eemail: false,
      Ename: false,
      // sms Editor
      Enumber: false,
      Esubj1: false,
      Ename1: false,

      showThisModel: false,
      activeOption: "questionn",
      heading: "",
      val1: "",
      val2: "",

      showCommentLeft: false,
      showVisitType: false,

      pat: {
        dosStr: "",
      },

      //-- Questionn
      showQuestionn: true,
      visitQuests: [],
      selectedCheckbox: null,

      //-- Comment
      commentText: "",
      commentsList: [],

      //-- visit type
      visitTypes: [],
      visitReasons: [],
      activeVisitReasons: [],

      //-- Payments
      ActivePaymentRequest: {},
      showRequestPayment: false,
      showCollectPayment: false,

      paymentMode: "payment-requested",
      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        ExpirationDate: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },

      aSingleRequestPayment: {
        amount: 0,
        email: "",
        phone: "",
        comment: "",
      },
      //Timer
      TimerObject: {},
      //-- Emails
      showEmail: false,
      emailTempsList: [],
      aSingleEmail: {
        name: "",
        emailText: "",
        emailSubject: "",
      },

      //-- sms
      showSms: false,
      smsTempsList: [],
      selectedSmsId: 0,
      aSingleSms: {
        name: "",
        smsText: "",
      },

      //-- Physicians
      showPhysician: false,
      //-- Resource
      showResource: false,
      phyList: [],

      //-- Merge
      showMerge: false,
      //-- Modals display
      cardModal: false,
      cashModal: false,
      chequeModal: false,
      // Menu
      menuitems: [
        {
          label: "Update",
          command: () => {
            this.$toast.add({
              severity: "success",
              summary: "Updated",
              detail: "Data Updated",
              life: 3000,
            });
          },
        },
        {
          label: "Delete",
          command: () => {
            this.$toast.add({
              severity: "warn",
              summary: "Delete",
              detail: "Data Deleted",
              life: 3000,
            });
          },
        },
        {
          label: "Vue Website",
          url: "https://vuejs.org/",
        },
        {
          label: "Router",
          to: "/fileupload",
        },
      ],
    };
  },
  methods: {
    //code for Data-Tables_
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 7);
      this.endDate.setDate(this.endDate.getDate() + 1);
      this.initDate =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);

      this.intDummyComm();
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDate);
      this.dummyComm.extras2 = this.dateToYMD(this.endDate);
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;

      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsListById";
      this.axiosGetData(url, this.dummyComm, 1);
    },
    // orderBy(column) {
    //   if (this.sortColumn == column) {
    //     switch (this.sortColumnOption) {
    //       case 0:
    //         this.sortColumnOption = 1;
    //         break;
    //       case 1:
    //         this.sortColumnOption = 2;
    //         break;
    //       case 2:
    //         this.sortColumn = 0;
    //         this.sortColumnOption = 0;
    //         break;
    //     }
    //   } else {
    //     this.sortColumn = column;
    //     this.sortColumnOption = 1;
    //   }
    //   this.pageNumber = 1;
    //   this.getPaymentResTabl();
    // },
    orderBy(column) {
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0),
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0),
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0),
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0),
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0),
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0),
          );
        }
      }
      if (column == 4) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.billNo < b.billNo ? 1 : b.billNo < a.billNo ? -1 : 0),
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.billNo > b.billNo ? 1 : b.billNo > a.billNo ? -1 : 0),
          );
        }
      }
      if (column == 5) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0),
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0),
          );
        }
      }
      if (column == 6) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr < b.billDateStr
                ? 1
                : b.billDateStr < a.billDateStr
                ? -1
                : 0,
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr > b.billDateStr
                ? 1
                : b.billDateStr > a.billDateStr
                ? -1
                : 0,
          );
        }
      }
      if (column == 7) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr < b.billDateStr
                ? 1
                : b.billDateStr < a.billDateStr
                ? -1
                : 0,
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr > b.billDateStr
                ? 1
                : b.billDateStr > a.billDateStr
                ? -1
                : 0,
          );
        }
      }
      if (column == 8) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount < b.amount ? 1 : b.amount < a.amount ? -1 : 0),
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount > b.amount ? 1 : b.amount > a.amount ? -1 : 0),
          );
        }
      }
      if (column == 9) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount < b.amount ? 1 : b.amount < a.amount ? -1 : 0),
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount > b.amount ? 1 : b.amount > a.amount ? -1 : 0),
          );
        }
      }
      if (column == 10) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.refundDateStr < b.refundDateStr
                ? 1
                : b.refundDateStr < a.refundDateStr
                ? -1
                : 0,
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.refundDateStr > b.refundDateStr
                ? 1
                : b.refundDateStr > a.refundDateStr
                ? -1
                : 0,
          );
        }
      }
      if (column == 11) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.comment < b.comment ? 1 : b.comment < a.comment ? -1 : 0,
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.comment > b.comment ? 1 : b.comment > a.comment ? -1 : 0,
          );
        }
      }
    },
    orderByRemeber(column) {
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.firstName < b.firstName
                ? 1
                : b.firstName < a.firstName
                ? -1
                : 0,
          );
        } else {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0,
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.dos < b.dos ? 1 : b.dos < a.dos ? -1 : 0),
          );
        } else {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.dos > b.dos ? 1 : b.dos > a.dos ? -1 : 0),
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDate < b.billDate ? 1 : b.billDate < a.billDate ? -1 : 0,
          );
        } else {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDate > b.billDate ? 1 : b.billDate > a.billDate ? -1 : 0,
          );
        }
      }
      if (column == 4) {
        if (this.asc_desc == "asc") {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.email < b.email ? 1 : b.email < a.email ? -1 : 0),
          );
        } else {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.email > b.email ? 1 : b.email > a.email ? -1 : 0),
          );
        }
      }
      if (column == 5) {
        if (this.asc_desc == "asc") {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.phone < b.phone ? 1 : b.phone < a.phone ? -1 : 0),
          );
        } else {
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.phone > b.phone ? 1 : b.phone > a.phone ? -1 : 0),
          );
        }
      }
      if (column == 6) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.amountStr < b.amountStr
                ? 1
                : b.amountStr < a.amountStr
                ? -1
                : 0,
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.amountStr > b.amountStr
                ? 1
                : b.amountStr > a.amountStr
                ? -1
                : 0,
          );
        }
      }
    },

    showReconcileModel(pay) {
      this.$confirm.require({
        message: "Are you sure?",
        header:
          "You want to Reconcile this Payment. This action cannot be undone. Are you sure you want to continue?",
        icon: "fa fa-exclamation-triangle",
        acceptLabel: "Change",
        acceptClass: "style='background-color: #00c292'",
        accept: () => {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          this.dummyComm.extras2 = pay.billNo;
          this.dummyComm.filter = "";

          const myData = {
            dc: this.dummyComm,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/ReconcilePaymentById";
          this.axiosGetData(url, myData).then((res) => {
            if (res == "err") {
              this.showErrorToast("Unable to save.");
            } else {
              this.showSuccessToast("Reconcile Payment Successful!");
              this.getPaymentResTabl();
            }
          });
        },
        reject: () => {
          this.showErrorToast("Action rejected");
        },
      });
    },

    statusChanged(pay) {
      // if changed to paid then show payment modals
      this.$confirm.require({
        message: "Are you sure?",
        header:
          "You want to change Payment Status. This action cannot be undone. Are you sure you want to continue?",
        icon: "fa fa-exclamation-triangle",
        acceptLabel: "Change",
        acceptClass: "style='background-color: #00c292'",
        accept: () => {
          //this.$toast.add({severity:'info', summary:'Confirmed', detail:'You have accepted', life: 3000});
          this.intDummyComm();
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;

          const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdatePaymentStatus";
          const myData = this.dummyComm;

          this.axiosGetData(url, myData).then((res) => {
            if (res == "err") {
              this.showErrorToast("Unable to save.");
            } else {
              this.showSuccessToast("Status Changed.");
              this.getPaymentResTabl();
            }
          });
          try {
            this.FetchTableData();
          } catch (e) {
            console.log(e.message);
          }
        },
        reject: () => {
          this.showErrorToast("Action rejected");
        },
      });
    },

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    mergeClick() {
      this.activeOption = "merge";
    },

    paymentModeStyle(what) {
      if (this.paymentMode == what) return "color: #FB9678; cursor: grab;";
      else return "color: #fbeee6; cursor: grab;";
    },

    showReminderModel(pay) {
      this.displayRem = true;

      this.Reminder = pay;
    },

    paymentModeClicked(val) {
      this.getPatientBasicInfo(val);
    },

    paymentCollectMethodModal(pay) {
      this.displayPayMethod = true;
      this.ActivePaymentRequest = pay;
      this.limitAmount = pay.amount;
      this.aSinglePaymentReceived.amount = this.ActivePaymentRequest.amount;
      this.aSinglePaymentReceived.tdNumber = "";
      //this.aSinglePaymentReceived.
      console.log(pay);
    },
    refundCollectMethodModal(pay) {
      this.displayRefundMethod = true;
      this.ActivePaymentRequest = pay;
      this.refundLimit = pay.amount;
    },

    //MethodType 1. Credit-Card, 2. Cash, 3. Cheque
    showSubmitPaymentModal(methodType) {
      this.displayPayMethod = false;
      if (methodType == 1) {
        this.cardModal = true;
      } else if (methodType == 2) {
        this.cashModal = true;
      } else if (methodType == 3) {
        this.chequeModal = true;
      }
      this.modelBackDrop = false;
    },
    showSubmitRefundModal(pay) {
      console.log(pay);
      this.ActivePaymentRequest = pay;

      this.refundMethodType = pay.paymentMethod;
      this.displayRefundMethod = false;
      this.refundAmountModal = true;
    },
    closeRefundAmountModal() {
      this.refundAmountModal = false;
    },
    //Refund section
    sendReceipt(pat, pay) {
      this.displayReceipt = true;

      console.log(pat);
      console.log(pay);
      this.SendReceiptRequest.PatientId = pat.patientId;
      this.SendReceiptRequest.PracticeId = pat.pacticeId;
      this.SendReceiptRequest.Email = pat.email;
      this.SendReceiptRequest.Phone = pat.phone;
      this.SendReceiptRequest.BillNo = pay.billNo;
      this.SendReceiptRequest.VisitId = pay.visitId;
      this.SendReceipt.LocalDateTime = new Date();
      this.SendReceiptRequest.PNDX = pay.pndx;
      this.displayReceipt = true;
    },
    sendReceiptClick() {
      this.displayReceipt = false;
      this.intDummyComm();
      this.dummyComm.patientId = this.patId;
      const url = this.SERVER + "/VNSPRAAPI/Payments/SendReceiptReminder";
      const myData = this.SendReceiptRequest;
      myData.DC = this.dummyComm;
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      this.axiosGetData(url, myData).then((res) => {
        if (res.status == false) {
          loader.hide();
          this.showErrorToast(res.message);
        } else {
          loader.hide();
          this.showSuccessToast("Send Receipt  Successful!");
          this.refundAmountModal = false;
        }
      });
    },

    refundPayment() {
      this.intDummyComm();
      this.dummyComm.patientId = this.patId;
      const url = this.SERVER + "/VNSPRAAPI/Payments/RefundPayment";
      const myData = {
        DC: this.dummyComm,
        BillNo: this.ActivePaymentRequest.billNo,
        DateLocalTime: new Date(),
        RefundMethod: this.refundMethodType,
        Amount: this.refundAmount,
      };
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      this.axiosGetData(url, myData).then((res) => {
        if (res == "err") {
          loader.hide();
          this.showErrorToast("Unable to load data.");
        } else {
          loader.hide();
          if (res.dc.auditFlag < 0) {
            this.showErrorToast(res.dc.auditFlagVal);
          } else {
            this.showSuccessToast("Amount Refunded Successful!");
            this.refundAmountModal = false;
          }

          for (let k = 0; k < res.list.length; k++) {
            //dos
            res.list[k].dos = res.list[k].dos.split("T");
            res.list[k].dos = res.list[k].dos[0];
            //dare req
            res.list[k].billDate = res.list[k].billDate.split("T");
            res.list[k].billDate = res.list[k].billDate[0];
          }
          this.refundAmount = "";
          this.filteredPaymentRequests = res.list;
          this.totalRows = res.dc.totalRow;
          this.totalPages = res.dc.totalPages;
        }
      });
      try {
        this.FetchTableData();
      } catch (e) {
        console.log(e.message);
      }
    },
    //Refund section

    questMultipleOptionSelected(quest, id) {
      id += "";
      let arr = quest.answer.split(",");
      if (quest.answer.includes(id)) {
        const x = arr.indexOf(id);
        arr.splice(x, 1);
      } else {
        arr.push(id);
      }
      quest.answer = arr.toString();
    },

    classQuestMultiple(quest, id) {
      id += "";
      let arr = quest.answer.split(",");
      const x = arr.indexOf(id);
      return x >= 0 ? "btn btn-info label1" : "btn btn-outline-info label1";
    },

    questSingleOptionSelected(quest, id) {
      quest.answer = id + "";
    },

    questionnClick() {
      this.getQuestData();
      this.activeOption = "questionn";
    },

    commentClick() {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetCommentsList";
      this.intDummyComm();
      if (typeof this.pat.visitId == "undefined") {
        this.dummyComm.visitId = this.p_visitId;
      } else {
        this.dummyComm.visitId = this.pat.visitId;
      }
      this.axiosGetData(url, this.dummyComm).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          // eslint-disable-line no-debugger
          this.commentsList = res;
        }
      });
      this.activeOption = "comment";
    },

    showCommentLine(ndx) {
      const xx = this.commentsList.length - 1;
      if (ndx < xx) return true;
      else return false;
    },

    collectPaymentClick() {
      this.activeOption = "collectpayment";
      this.getPaymentResTabl();
    },

    requestPaymentClick() {
      this.activeOption = "request-payment";
    },

    getPaymentResTabl() {
      this.intDummyComm();
      this.dummyComm.patientId = this.patId;
      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsListyId";
      const myData = this.dummyComm;
      this.$nextTick(() => {
        this.$refs.cp.getPaymentResTable(this.p_visitId, this.patId);
      });
    },

    visitTypeClick() {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.intDummyComm();
      if (typeof this.pat.patientId == "undefined") {
        this.dummyComm.extras = this.p_visitId;
      } else {
        this.dummyComm.extras = this.pat.patientId;
      }
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTypRea";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          this.visitTypes = res.types;
          this.visitReasons = res.reasons;
          this.getActiveVisitReasons(this.pat.visitTypeId);
        }
      });

      this.activeOption = "visittype";
    },

    emailTempsListClick(email) {
      if (email.name != "Compose") {
        this.Eemail = true;
        this.Esubj = true;
        this.setReadonly = true;
        this.Ename = true;
      } else {
        this.Eemail = false;
        this.Esubj = false;
        this.setReadonly = false;
        this.Ename = false;
      }
      this.aSingleEmail.emailTemplateId = email.emailTemplateId;
      if (email.emailTemplateId > 0)
        this.aSingleEmail = JSON.parse(JSON.stringify(email));
      else
        this.aSingleEmail = {
          name: "",
          emailTemplateId: 0,
          emailSubject: "",
          email: "",
          emailText: "",
        };
    },

    selectedEmailTempClass(email) {
      if (email.emailTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.aSingleEmail.emailTemplateId == email.emailTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },

    selectedEmailTempIcon(email) {
      if (email.emailTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },

    selectedSmsTempClass(sms) {
      if (sms.smsTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.selectedSmsId == sms.smsTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },

    selectedSmsTempIcon(sms) {
      if (sms.smsTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },

    smsTempsListClick(sms) {
      if (sms.name != "Compose") {
        this.Enumber = true;
        this.Esubj1 = true;
        this.Ename1 = true;
      } else {
        this.Enumber = false;
        this.Esubj1 = false;
        this.Ename1 = false;
      }
      this.selectedSmsId = sms.smsTemplateId;
      if (sms.smsTemplateId > 0)
        this.aSingleSms = JSON.parse(JSON.stringify(sms));
      else this.aSingleSms = { name: "", smsTemplateId: 0, smsText: "" };
    },

    sendTextClick() {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTxtTem";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          // eslint-disable-line no-debugger
          this.smsTempsList = res;
          this.smsTempsList.splice(0, 0, {
            name: "Compose",
            emailTemplateId: 0,
            emailText: "",
          });
        }
      });

      this.activeOption = "sms";
    },

    sendEmailClick() {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          this.emailTempsList = res;
          this.emailTempsList.splice(0, 0, {
            name: "Compose",
            emailTemplateId: 0,
            emailText: "",
          });
        }
      });

      this.activeOption = "email";
    },

    sendEmail() {
      if (this.aSingleEmail.name == "") {
        this.ShowWarning("Name is require");
        return;
      }
      if (this.pat.email == "") {
        this.ShowWarning("Email is require");
        return;
      }
      if (this.aSingleEmail.emailText == "") {
        this.ShowWarning("Text is require");
        return;
      }
      if (this.aSingleEmail.emailSubject == "") {
        this.ShowWarning("Subject is require");
        return;
      }
      if (this.pat.email != null) {
        if (!this.validEmail(this.pat.email)) {
          this.Validity(this.e);
        }
      }

      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.dummyComm.extras = "";

      const url = this.SERVER + "/VNSPRAAPI/Patient/SendEmail";
      const EmailData = {
        SentTo: this.pat.email,
        SentFrom: "",
        Password: "",
        EmailTemplateId: this.aSingleEmail.emailTemplateId,
        Body: this.aSingleEmail.emailText,
        Subject: this.aSingleEmail.emailSubject,
        TemplateName: this.aSingleEmail.name,
        UserId: this.dummyComm.ownerId,
        OwnerId: this.dummyComm.ownerId,
        PracticeId: this.dummyComm.practiceId,
        PatientId: this.pat.patientId,
        VisitId: this.pat.visitId,
        SentLocal: new Date(),
        //SentServer:
      };
      const myObject = {
        dc: this.dummyComm,
        email: EmailData,
      };

      this.axiosGetData(url, myObject).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to save data.");
        } else {
          this.showSuccessToast("Email sent successfully.");
        }
      });
      try {
        this.FetchTableData();
      } catch (e) {
        console.log(e.message);
      }
    },

    sendReminderClick() {
      if (this.Reminder.email == "") {
        this.showErrorToast("Email is require");
        return;
      }
      if (this.Reminder.phone == "") {
        this.showErrorToast("Phone is require");
        return;
      }

      this.intDummyComm();
      this.dummyComm.visitId = this.pat.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      const url = this.SERVER + "/VNSPRAAPI/Trackers/SendPaymntReminder";

      const Reminder1 = {
        PNDX: this.Reminder.pndx,
        BillNo: this.Reminder.billNo,
        VisitId: this.Reminder.visitId,
        PatientId: this.Reminder.patientId,
        Amount: this.Reminder.amount,
        Email: this.Reminder.email,
        Phone: this.Reminder.phone,
      };

      const myData = { dc: this.dummyComm, pr: Reminder1 };

      this.axiosGetData(url, myData).then((res) => {
        if (res == "err") {
          this.showErrorToast("Unable to save data.");
        } else {
          this.showSuccessToast("Reminder sent successfully.");
          this.displayRem = false;
        }
      });
      try {
        this.FetchTableData();
      } catch (e) {
        console.log(e.message);
      }
    },

    sendSms() {
      if (this.aSingleSms.name == "") {
        this.showErrorToast("Name is require");
        return;
      }
      if (this.pat.phone == "") {
        this.showErrorToast("Phone is require");
        return;
      }
      if (this.aSingleSms.smsText == "") {
        this.showErrorToast("Text is require");
        return;
      }

      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";

      const dc = this.dummyComm;
      const Sms = {
        SmsTemplateId: this.aSingleSms.smsTemplateId,
        PhoneNumber: this.pat.phone,
        MessageBody: this.aSingleSms.smsText,
        PatientID: this.pat.patientId,
        UserId: 0,
        VisitId: this.pat.visitId,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };

      this.axiosGetData(url, myData).then((res) => {
        loader.hide();
        if (res == "err") {
          this.showErrorToast("Unable to save data.");
        } else {
          this.showSuccessToast("Sms sent successfully.");
        }
      });
      try {
        this.FetchTableData();
      } catch (e) {
        console.log(e.message);
      }
    },

    getActiveVisitReasons(id) {
      this.activeVisitReasons = [];
      this.activeVisitReasons = this.visitReasons.filter(
        (f) => f.visitTypeId == id,
      );
    },

    resetVisitDetail() {
      this.pat.visitDetailId = 0;
    },

    classActiveOption(val) {
      if (val == this.activeOption) return "nav-link text-nowrap active";
      else return "nav-link text-nowrap";
    },

    cancelButtonClick() {
      this.closeModal();
    },

    closeModal() {
      this.showThisModel = false;
      this.$emit("close-modal", false);
      //$("#add_folder").modal("hide");
    },

    closeModalRem() {
      this.displayRem = false;
      this.modelBackDrop = true;
      //$("#add_folder").modal("hide");
    },

    loadInit() {
      this.StartLogoutTime();
    },

    deletePayment(pay) {
      //abcd
      this.$confirm.require({
        message: "Are you sure?",
        header:
          "You want to Delete this Payment. This action \n cannot be undone. Are you sure you want to continue?",
        icon: "fa fa-exclamation-triangle",
        acceptLabel: "Delete",
        acceptClass: "style='background-color: #00c292'",
        accept: () => {
          //this.$toast.add({severity:'info', summary:'Confirmed', detail:'You have accepted', life: 3000});
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          const obj = {
            DC: this.dummyComm,
            PR: pay,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/DeletePayment";
          const myData = obj;
          var loader = this.$loading.show({
            // Optional parameters
            color: "#03a9f3",
          });
          this.axiosGetData(url, myData).then((res) => {
            if (res == "err") {
              loader.hide();
              this.showErrorToast("Unable to save.");
            } else {
              loader.hide();
              this.filteredPaymentRequests = res.list;
              this.showSuccessToast("Payment Deleted.");

              // this.getPaymentResTabl();
            }
          });
          try {
            this.FetchTableData();
          } catch (e) {
            console.log(e.message);
          }
        },
        reject: () => {
          this.showErrorToast("Action rejected");
        },
      });
    },

    updateTypeReasonClick() {
      if (!this.pat.visitTypeId || !this.pat.visitDetailId) {
        this.showErrorToast("Invalid Visit Type/Reason.");
        return;
      }

      if (!this.isValidateDate(this.pat.dosStr)) {
        this.showErrorToast("Invalid Date of Service.");
        return;
      }

      this.$confirm.require({
        message:
          "This action cannot be undone. Are you sure you want to continue?",
        header:
          "After changing the Visit Type/Reason old Questionnaire and their Answers will be deleted PERMANENTLY.   ",
        icon: "fa fa-exclamation-triangle",
        acceptLabel: "Change",
        acceptClass: "style='background-color: #00c292'",
        accept: () => {
          //this.$toast.add({severity:'info', summary:'Confirmed', detail:'You have accepted', life: 3000});
          var loader = this.$loading.show({
            color: "#03a9f3",
          });
          this.intDummyComm();
          this.dummyComm.extras = "";
          this.dummyComm.visitId = this.pat.visitId;
          const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdPatTypRea";
          const myData = {
            dc: this.dummyComm,
            patientInfo: this.pat,
          };

          this.axiosGetData(url, myData).then((res) => {
            loader.hide();
            if (res == "err") {
              this.showErrorToast("Unable to save.");
            } else {
              this.showSuccessToast("Visit Type saved successfully.");
              this.FetchTableData();
            }
          });
        },
        reject: () => {
          this.showErrorToast("Action rejected");
        },
      });
    },

    questSaveClick() {
      let err = 0;
      for (let k = 0; k < this.visitQuests.length; k++) {
        if (this.visitQuests[k].answer == "") {
          //this.ShowWarning("All Questionnaire Input is require");
          //return;
          err = 1;
        }
        if (this.visitQuests[k].questTypeName == "Phone Number") {
          if (this.visitQuests[k].answer.length < 12) {
            // this.ShowWarning("Phone must be of 10 length");
            // return;
            err = 2;
          }
        }
        // if (this.visitQuests[k].questTypeName == "Date") {
        //   // this.visitQuests[k].answer = this.dateToYMD(
        //   //   this.visitQuests[k].answer
        //   // );
        //   if (!this.isValidateDate(this.visitQuests[k].answer)) {
        //     // this.ShowWarning("Valid Date of Birth required");
        //     // return;
        //     err = 3;
        //   }
        // }
        if (this.visitQuests[k].questTypeName == "Email") {
          if (this.visitQuests[k].answer != null) {
            if (!this.validEmail(this.visitQuests[k].answer)) {
              // this.ShowWarning("Valid Date of Birth required");
              // return;
              err = 4;
            }
          }
        }
      }

      if (err > 0) {
        this.showErrorToast("Missing answers to required questions.");
        return;
      } else {
        this.intDummyComm();
        this.dummyComm.visitId = this.p_visitId;
        this.dummyComm.patientId = this.pat.patientId;

        this.dummyComm.extras = this.pat.patientId;
        this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
        const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdVisQue";
        const myData = {
          dc: this.dummyComm,
          quests: this.visitQuests,
        };
        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });

        this.axiosGetData(url, myData)
          .then((res) => {
            if (res == "err") {
              this.showErrorToast("Unable to save.");
            } else {
              this.showSuccessToast("Questionnaire(s) saved successfully.");
            }
          })
          .finally(() => {
            loader.hide();
          });

        try {
          this.FetchTableData();
        } catch (e) {
          console.log(e.message);
        }
      }
    },

    getPatientBasicInfo(what = "") {
      this.intDummyComm();
      this.dummyComm.visitId = this.p_visitId;
      let url = this.SERVER + "/VNSPRAAPI/DropdownModal/GetPatientBasicInfo";
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      this.axiosGetData(url, this.dummyComm).then((res) => {
        if (res == "err") {
          loader.hide();
          this.pat = "";
          this.heading = "Patient not found.";
        } else {
          loader.hide();
          this.pat = res;

          if (res.appointmentTime != null) {
            var newAppointmentTimeValue = new Date(
              res.appointmentTime,
            ).toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: false,
            });
            this.pat.appointmentTime = newAppointmentTimeValue;
          }

          this.patId = res.patientId;
          this.pat.dosStr = this.dateToYMD(this.pat.dos);
          this.val1 = this.pat.dos.split("T")[0];
          this.val2 = this.val1.split("-")[0].substring(2, 4);
          this.val1 = this.val1.split("-")[1];
          if (this.val1.length == 1) {
            this.val1 = "0" + this.val1;
          }
          this.heading = `${res.firstName} ${res.lastName} - ${res.dob} `;
          if (res.patientId * 1 > 0)
            this.heading += `- PT${this.dummyComm.prId}${this.val1}${this.val2}${res.patientId}-${res.vid}`;
          if (what == "payment-requested") {
            this.getPaymentResTabl();
          }
        }
      });
    },

    getQuestData() {
      this.intDummyComm();
      this.dummyComm.visitId = this.p_visitId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetVisQueDat";

      this.axiosGetData(url, this.dummyComm).then((res) => {
        if (res == "err") {
          this.visitQuests = "";
          this.showErrorToast("No questions found");
        } else {
          this.visitQuests = res.quests;
        }
      });
    },

    leaveCommentSaveClick() {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      if (this.commentText.length < 1) {
        this.showErrorToast("Comment is required.");
        return;
      } else {
        const url = this.SERVER + "/VNSPRAAPI/Trackers/SaveComment";
        this.intDummyComm();
        this.dummyComm.extras = this.commentText;
        this.dummyComm.visitId = this.pat.visitId;
        this.dummyComm.patientId = this.pat.patientId;
        this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
        this.axiosGetData(url, this.dummyComm).then((res) => {
          loader.hide();
          if (res == "err") {
            this.showErrorToast("Unable to save.");
          } else {
            this.showSuccessToast("Comment saved successfully.");
            this.commentClick();
          }
        });
        try {
          this.FetchTableData();
        } catch (e) {
          console.log(e.message);
        }
      }
    },

    paymentReceivedClick(what) {
      const valueAmount = this.aSinglePaymentReceived.amount;

      if (what == "cheque") {
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Cheque Number is require");
          event.preventDefault();
          return;
        }
        // if (this.aSinglePaymentReceived.tdNumber.length < 19) {
        //   this.showErrorToast("Card Number length must be 12");
        //   return;
        // }
        if (this.aSinglePaymentReceived.holderName == 0) {
          this.showErrorToast("Holder name is require");
          return;
        }
        if (this.aSinglePaymentReceived.comment == 0) {
          this.showErrorToast("comment is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
        if (this.aSinglePaymentReceived.amount > this.limitAmount) {
          this.showErrorToast(
            "Amount can not be greater then requested $" + this.limitAmount,
          );
          return;
        }
      }
      if (what == "cash") {
        if (this.aSinglePaymentReceived.amount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      } else if (what == "credit-card") {
        if (this.aSinglePaymentReceived.cardCVC == "") {
          this.showErrorToast("Card CVC is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Card CVC must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.comment == "") {
          this.showErrorToast("Comment is require");
          return;
        }
        if (this.aSinglePaymentReceived.zip == "") {
          this.showErrorToast("Zip is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Zip must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Card Number is require");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.showErrorToast("Card Number length must be 16");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == "") {
          this.ShowWarning("Holder Name is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      }
      this.aSinglePaymentReceived.paymentMethod = what;
      this.aSinglePaymentReceived.visitId = this.pat.visitId;
      this.aSinglePaymentReceived.patientId = this.pat.patientId;
      this.aSinglePaymentReceived.pndx = this.ActivePaymentRequest.pndx;

      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayRec";
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      const myData = { dc: this.dummyComm, pr: this.aSinglePaymentReceived };
      this.btnProColl = true;
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      this.axiosGetData(url, myData)
        .then((res) => {
          //console.log("HHHHHHH", res);

          if (res == "err" || res.dc.auditFlag < 0) {
            this.ShowError("Unable to save. " + res.dc.auditFlagVal);
            this.btnProColl = false;
            loader.hide();
          } else {
            for (let k = 0; k < res.list.length; k++) {
              //dos
              res.list[k].dos = res.list[k].dos.split("T");
              res.list[k].dos = res.list[k].dos[0];
              //dare req
              res.list[k].billDate = res.list[k].billDate.split("T");
              res.list[k].billDate = res.list[k].billDate[0];
            }
            loader.hide();

            this.filteredPaymentRequests = res.list;
            this.totalRows = res.dc.totalRow;
            this.totalPages = res.dc.totalPages;
            this.ShowSuccess("Payment processed successfully.");
            this.btnProColl = false;
            this.aSinglePaymentReceived.tdNumber = "";
            this.aSinglePaymentReceived.holderName = "";
            this.aSinglePaymentReceived.cardCVC = "";
            this.aSinglePaymentReceived.ExpirationDate = "";
            this.aSinglePaymentReceived.comment = "";
            this.aSinglePaymentReceived.zip = "";
            this.aSinglePaymentReceived.amount = "";
            this.cardModal = false;
            this.chequeModal = false;
            this.cashModal = false;
          }
        })
        .finally(() => {
          loader.hide();
        });
    },

    savePaymentRequest() {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      var valueAmount = this.aSingleRequestPayment.amount;

      if (this.aSingleRequestPayment.phone == "") {
        this.showErrorToast("Phone is require");
        return;
      }
      if (this.aSingleRequestPayment.phone.length < 12) {
        this.showErrorToast("Phone length must be 10");
        return;
      }
      if (this.aSingleRequestPayment.email == "") {
        this.showErrorToast("Email is require");
        return;
      }
      if (valueAmount < 0) {
        this.showErrorToast("Invalid Amount");
        return;
      }
      if (this.aSingleRequestPayment.comment == "") {
        this.showErrorToast("Comment is require");
        return;
      }
      if (this.aSingleRequestPayment.email != null) {
        if (!this.validEmail(this.aSingleRequestPayment.email)) {
          this.Validity(this.e);
        }
      }
      //this.aSingleRequestPayment.fndx = this.pat.pndx;
      this.aSingleRequestPayment.visitId = this.pat.visitId;

      this.intDummyComm();
      //const dd = new Date();
      this.dummyComm.visitId = this.pat.visitId;
      this.dummyComm.patientId = this.pat.patientId;
      this.aSingleRequestPayment.patientId = this.pat.patientId;

      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      this.dummyComm.extras = this.dateToLocalString(new Date());
      this.dummyComm.myDate = this.dateToLocalString(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayReq";
      const myData = {
        dc: this.dummyComm,
        pr: this.aSingleRequestPayment,
      };

      this.axiosGetData(url, myData).then((res) => {
        loader.hide();
        if (res == "err" || res.dc.auditFlag < 0) {
          this.showErrorToast("Unable to save. " + res.dc.auditFlagVal);
        } else {
          this.showSuccessToast("Data saved successfully.");
        }
      });
      try {
        this.FetchTableData();
      } catch (e) {
        console.log(e.message);
      }
    },

    assignPhysicianStyle(phy) {
      // eslint-disable-line no-debugger
      if (phy.physicianId == this.pat.physicianId)
        return "btn btn-info assignPhyStage";
      else return "btn btn-dark assignPhyStage";
    },

    assignPhysicianSaveClick(phy) {
      if (phy.physicianId == this.pat.physicianId) return;

      this.$confirm.require({
        message: "Are you sure you want to proceed?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          var loader = this.$loading.show({
            color: "#03a9f3",
          });
          const dd = new Date();
          this.intDummyComm();
          this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
          this.dummyComm.visitId = this.pat.visitId;
          this.dummyComm.patientId = this.pat.patientId;

          const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdPhy";
          this.dummyComm.extras = this.mixinMakeCommString(
            this.pat.pndx,
            phy.userId,
            dd.toLocaleDateString() + " " + dd.toLocaleTimeString(),
          );
          const myData = { dc: this.dummyComm, patientInfo: this.pat };
          this.axiosGetData(url, myData).then((res) => {
            loader.hide();
            if (res == "err" || res.dc.auditFlag < 0) {
              this.showErrorToast("Unable to save. " + res.dc.auditFlagVal);
            } else {
              this.showSuccessToast("Data saved successfully.");
              this.pat.physicianId = phy.physicianId;
            }
          });
          try {
            this.FetchTableData();
          } catch (e) {
            console.log(e.message);
          }
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },

    assignPhysicianClick() {
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Practices/GTPHINF1";
      const myData = this.dummyComm;

      this.axiosGetData(url, myData).then((res) => {
        if (res == "err" || res.dc.auditFlag < 0) {
          this.showErrorToast("Unable to load data. " + res.dc.auditFlagVal);
        } else {
          this.phyList = res.ph;
          this.activeOption = "physician";
        }
      });
    },
    assignResourceClick() {
      this.activeOption = "Resource";
    },
    async assignTaskClick() {
      this.activeOption = "Tasks";
      this.$nextTick(() => {
        try {
          this.$refs.patientTasksTableRef2.getTaskClick(this.p_visitId);
        } catch {
          return -1;
        }
      });
    },
    async auditLogClick() {
      this.activeOption = "auditLog";
      this.$nextTick(() => {
        try {
          this.$refs.auditLogComponent.loadInitVisit(this.p_visitId);
        } catch {
          return -1;
        }
      });
    },
    showEditModel(pay) {
      this.EditPaymentRequest = true;
      this.ActivePaymentRequest = pay;
    },
    //-------------------- Common Methods
    async axiosGetData(myUrl, myData) {
      let data = "err";
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          data = res.data;
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(() => {
          this.ResetLogoutTime();
          this.btnProColl = false;
        });

      return data;
    }, // axiosGetData
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    closeRecepit() {
      this.displayReceipt = false;
    },

    amountRefundCheck(evt, val) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        //Beautiful
        val = val + String.fromCharCode(evt.keyCode);
        if (
          parseFloat(val) >
          this.ActivePaymentRequest.amount -
            this.ActivePaymentRequest.refundAmount
        ) {
          evt.preventDefault();
          return;
        }
        return true;
      }
    },
    colorStyle(status) {
      if (status == 1) {
        //Requested
        return "background-color:#03a9f3 ;border-color:#03a9f3";
      } else if (status == 2) {
        //Pending
        return "background-color:#03a9f3 ;border-color:#03a9f3";
      } else if (status == 3) {
        //Disputed
        return "background-color:black; border-color:black";
      } else if (status == 4) {
        //Paid
        return "background-color:#00C292; border-color:#00C292";
      } else if (status == 5) {
        //ReFund
        return "background-color:#dc3f4e; border-color:#dc3f4e";
      } else if (status == 6) {
        //PartiallyRefunded
        return "background-color:#DFCE1D; border-color:#DFCE1D";
      } else if (status == 7) {
        //PartiallyPaid
        return "background-color:#03a9f3; border-color:#03a9f3";
      } else if (status == 7) {
        //Deleted
        return "background-color:#03a9f3; border-color:#03a9f3";
      } else if (status == 9) {
        //Reconciled
        return "background-color:#d19e01; border-color:#d19e01";
      }
    },
    gotoCheckHolderName() {
      let checkHolderNameRef = this.$refs.checkHolderNameRef;
      checkHolderNameRef.focus();
    },
    gotoComment() {
      alert();
      let commentRef = this.$refs.commentRef;
      commentRef.focus();
    },
  }, // methods

  watch: {
    visitQuests: function (q) {
      console.log(q);
    },
    activeOption: function (val) {
      this.showCommentLeft = false;
      this.showVisitType = false;
      this.showQuestionn = false;
      this.showCollectPayment = false;
      this.showEmail = false;
      this.showSms = false;
      this.showRequestPayment = false;
      this.showPhysician = false;
      this.showResource = false;
      this.showMerge = false;
      this.showTasks = false;
      this.showAuditLog = false;

      switch (val) {
        case "merge":
          this.showMerge = true;
          break;
        case "questionn":
          this.showQuestionn = true;
          break;
        case "comment":
          this.showCommentLeft = true;
          break;
        case "visittype":
          this.showVisitType = true;
          break;
        case "collectpayment":
          this.showCollectPayment = true;
          break;
        case "physician":
          this.showPhysician = true;
          break;
        case "request-payment":
          this.showRequestPayment = true;
          break;
        case "email":
          this.showEmail = true;
          break;
        case "sms":
          this.showSms = true;
          break;
        case "Resource":
          this.showResource = true;
          break;
        case "Tasks":
          this.showTasks = true;
          break;
        case "auditLog":
          this.showAuditLog = true;
          break;
      }
      this.pat.dosStr = this.dateToYMD(this.pat.dos);
    },

    "pat.visitTypeId": function () {
      this.getActiveVisitReasons(this.pat.visitTypeId);
    },

    commentsList: function (val) {
      for (let i = 0; i < val.length; i++) {
        const dd = new Date(val[i].commentLocalDate);
        val[i].commentLocalDate =
          dd.toLocaleDateString() + " " + dd.toLocaleTimeString();
      }
    },
  }, // watch

  mounted() {
    this.getPatientBasicInfo();
    if (this.button_Name == "") {
      this.activeOption = "visittype";
      this.visitTypeClick();
    } else if (this.button_Name == "visittype") {
      this.activeOption = this.button_Name;
      this.visitTypeClick();
    } else if (this.button_Name == "comment") {
      this.activeOption = this.button_Name;
      this.commentClick();
    } else if (this.button_Name == "collectpayment") {
      this.activeOption = this.button_Name;
      this.paymentModeClicked("payment-requested");
    } else if (this.button_Name == "Tasks") {
      this.activeOption = this.button_Name;
      this.assignTaskClick();
    }
    this.showThisModel = true;
  },
  unmounted() {
    clearTimeout(this.TimerObject);
  },
};
